module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/team-hero-6ce88ec05186c6532da5695f92f22ceb.png";